import { createTheme } from '@mui/material/styles';

const colors = {
  ink: '#1a1d31',
  inkSoft: '#575b74',
  paper: '#f7f5ef',
  paper2: '#efece2',
  card: '#fffdf8',
  night: '#101228',
  night2: '#171a38',
  amber: '#ffb648',
  amberDeep: '#e2921f',
  peri: '#8d95ff',
  green: '#46c98e',
  rose: '#ff8e7a',
};

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: colors.amber, dark: colors.amberDeep, contrastText: '#1e1503' },
    secondary: { main: colors.peri },
    success: { main: colors.green },
    error: { main: colors.rose },
    background: { default: colors.paper, paper: colors.card },
    text: { primary: colors.ink, secondary: colors.inkSoft },
    divider: 'rgba(26,29,49,.13)',
  },
  typography: {
    fontFamily: '"Instrument Sans", ui-sans-serif, system-ui, sans-serif',
    h1: {
      fontFamily: '"Bricolage Grotesque", "Instrument Sans", sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.035em',
      lineHeight: 1.02,
    },
    h2: {
      fontFamily: '"Bricolage Grotesque", "Instrument Sans", sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.028em',
      lineHeight: 1.08,
    },
    h3: {
      fontFamily: '"Bricolage Grotesque", "Instrument Sans", sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.018em',
    },
    h4: {
      fontFamily: '"Bricolage Grotesque", "Instrument Sans", sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.014em',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: { borderRadius: 7 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundColor: colors.paper },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 7,
          minHeight: 20,
          paddingInline: 20,
        },
        containedPrimary: {
          boxShadow: '0 10px 28px rgba(255,182,72,.25)',
          '&:hover': { boxShadow: '0 14px 34px rgba(255,182,72,.35)' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid rgba(26,29,49,.13)',
          boxShadow: '0 16px 45px rgba(26,29,49,.065)',
        },
      },
    },
    MuiTextField: {
      defaultProps: { size: 'small' },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600, borderRadius: 7 },
      },
    },
  },
});
